import { createStyledBreakpointsTheme } from 'styled-breakpoints'
import { useState, useEffect } from 'react'

export const getPrimaryTheme = (colorMode: 'light' | 'dark', tenant: Tenant) =>
  ({
    colorMode: colorMode,
    backgroundColor: colorMode === 'light' ? '#ffffff' : '#121212',
    backgroundColorInverted: colorMode === 'dark' ? '#ffffff' : '#121212',
    backgroundColorRgb: colorMode === 'light' ? '255, 255, 255' : '18, 18, 18',
    backgroundColorInvertedRgb:
      colorMode === 'dark' ? '255, 255, 255' : '18, 18, 18',
    textColor: colorMode === 'light' ? '#121212' : '#f4f4f4',
    textColorInverted: colorMode === 'dark' ? '#ffffff' : '#ffffff',
    greyLight: colorMode === 'light' ? '#e9ebef' : '#454648',
    greyDark: colorMode === 'light' ? '#9298aa' : '#787b7e',
    mainColor: colorMode === 'light' ? '255, 229, 117' : '255, 228, 98',
    secondaryColor: colorMode === 'light' ? '255, 137, 8' : '244, 69, 83',
    tenantColor:
      colorMode === 'light'
        ? tenant.key === '24heures'
          ? '#d9000b'
          : tenant.key === 'tdg'
          ? '#2c3890'
          : '#0a79bd'
        : tenant.key === '24heures'
        ? '#ffffff'
        : tenant.key === 'tdg'
        ? '#ffffff'
        : '#ffffff',
  } as const)

export const GetTheme = (colorMode: 'light' | 'dark', tenant: Tenant) => {
  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ])
  const [orientation, setOrientation] = useState(
    window.innerWidth > window.innerHeight ? 'landscape' : 'portrait'
  )

  useEffect(() => {
    const handleResize = () => {
      if (
        window.innerWidth === windowSize[0] &&
        window.innerHeight > windowSize[1]
      ) {
        setWindowSize([windowSize[0], window.innerHeight])
      } else if (window.innerWidth !== windowSize[0]) {
        setWindowSize([window.innerWidth, window.innerHeight])
      }

      if (window.innerWidth > window.innerHeight) {
        setOrientation('landscape')
      } else {
        setOrientation('portrait')
      }
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [windowSize])

  return {
    ...getPrimaryTheme(colorMode, tenant),
    initialHeight: windowSize[1],
    orientation: orientation,
    ...createStyledBreakpointsTheme({
      breakpoints: {
        xs: '0px',
        sm: '576px',
        md: '768px',
        lg: '992px',
        xl: '1200px',
        xxl: '1400px',
        xxxl: '1580px',
      },
    }),
  }
}
